// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1eAj7","noInteraction":"EventWrapper_noInteraction__TqATT","pointerPassthrough":"EventWrapper_pointerPassthrough__2sCJG"};